"use client";

import React from "react";

export interface UniversityPartnersProps {
  title?: string;
  partners: {
    name: string;
    logo: string;
  }[];
}

export function UniversityPartners({ 
  title = "Alli's University Partners",
  partners 
}: UniversityPartnersProps) {
  return (
    <>
      <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-scroll {
          animation: scroll 30s linear infinite;
        }
      `}</style>
      <section className="py-12 bg-white">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-8">
            {title}
          </h2>
          <div className="relative overflow-hidden">
            <div className="flex gap-8 animate-scroll">
              {/* First set of logos */}
              <div className="flex gap-8 shrink-0">
                {partners.map((partner, idx) => (
                  <div key={idx} className="w-56 h-28 flex items-center justify-center">
                    <img 
                      src={partner.logo} 
                      alt={partner.name} 
                      className="max-h-full max-w-full object-contain" 
                    />
                  </div>
                ))}
              </div>
              {/* Duplicate set for seamless loop */}
              <div className="flex gap-8 shrink-0">
                {partners.map((partner, idx) => (
                  <div key={`dup-${idx}`} className="w-56 h-28 flex items-center justify-center">
                    <img 
                      src={partner.logo} 
                      alt={partner.name} 
                      className="max-h-full max-w-full object-contain" 
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}